<div fxLayoutAlign="center center" fxLayout="column">
  <div class="mat-display-4 tvp-primary tvp-page-not-found">404</div>
  <h1 class="mat-body-2 tvp-center">{{ 'Tvp.PageNotFound.Title1' | translate }}</h1>
  <p class="mat-body-1 tvp-center">{{ 'Tvp.PageNotFound.Subtitle' | translate }}</p>
</div>
